import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import axios, { AxiosError } from "axios";
import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'viewpoints-comparisons',
  props: {
    type: {}
  },
  setup(__props: any) {

const props = __props;

const html = ref<string>("");

async function fetchRazorPartial() {
  const API_URL = `/api/htmlpartial/viewpointscomparisons/${props.type}`;

  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (err) {
    const e = err as AxiosError;
    throw new Error(`Error fetching the report: ${e.response?.data}`);
  }
}

onMounted(async () => {
  html.value = await fetchRazorPartial();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { innerHTML: html.value }, null, 8, _hoisted_1))
}
}

})